import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const apiUrl = process.env.REACT_APP_API_BASE_URL;

export const couponApiSlice = createApi({
  reducerPath: 'couponApi',
  baseQuery: fetchBaseQuery({ baseUrl: apiUrl }),
  endpoints: (builder) => ({
    // ✅ Add a single coupon
    createCoupon: builder.mutation({
      query: (data) => ({
        url: '/coupon/add',
        method: 'POST',
        body: data,
      }),
    }),

    // ✅ Add multiple coupons
    addAllCoupons: builder.mutation({
      query: (data) => ({
        url: '/coupon/all',
        method: 'POST',
        body: data,
      }),
    }),

    // ✅ Get all coupons
    fetchAllCoupons: builder.query({
      query: () => '/coupon',
    }),

    // ✅ Get a single coupon by ID
    fetchCouponById: builder.query({
      query: (id) => `/coupon/${id}`,
    }),

    // ✅ Update a coupon by ID
    updateCoupon: builder.mutation({
      query: ({ id, data }) => ({
        url: `/coupon/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),

    // ✅ Delete a coupon by ID
    deleteCoupon: builder.mutation({
      query: (id) => ({
        url: `/coupon/${id}`,
        method: 'DELETE',
      }),
    }),

    // ✅ Apply coupon
    applyCoupon: builder.mutation({
      query: (code) => ({
        url: '/coupon/code/apply',
        method: 'POST',
        body: { code },
      }),
    }),
  }),
});

export const {
  useCreateCouponMutation,
  useAddAllCouponsMutation,
  useFetchAllCouponsQuery,
  useFetchCouponByIdQuery,
  useUpdateCouponMutation,
  useDeleteCouponMutation,
  useApplyCouponMutation,
} = couponApiSlice;

export const couponApiReducer = couponApiSlice.reducer;
